var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactivePin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5059_6321)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5059_6321",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1655 24.1839C23.1753 22.5421 26 18.6009 26 14C26 7.92487 21.0751 3 15 3C8.92487 3 4 7.92487 4 14C4 18.6009 6.82471 22.5421 10.8345 24.1839L15 32L19.1655 24.1839Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1655 24.1839C23.1753 22.5421 26 18.6009 26 14C26 7.92487 21.0751 3 15 3C8.92487 3 4 7.92487 4 14C4 18.6009 6.82471 22.5421 10.8345 24.1839L15 32L19.1655 24.1839Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1655 24.1839L18.7866 23.2585L18.4527 23.3952L18.283 23.7136L19.1655 24.1839ZM10.8345 24.1839L11.717 23.7136L11.5473 23.3952L11.2134 23.2585L10.8345 24.1839ZM15 32L14.1175 32.4703L15 34.1262L15.8825 32.4703L15 32ZM25 14C25 18.1811 22.4337 21.7652 18.7866 23.2585L19.5444 25.1094C23.9169 23.319 27 19.0208 27 14H25ZM15 4C20.5228 4 25 8.47715 25 14H27C27 7.37258 21.6274 2 15 2V4ZM5 14C5 8.47715 9.47715 4 15 4V2C8.37258 2 3 7.37258 3 14H5ZM11.2134 23.2585C7.56627 21.7652 5 18.1811 5 14H3C3 19.0208 6.08314 23.319 10.4556 25.1094L11.2134 23.2585ZM15.8825 31.5297L11.717 23.7136L9.95202 24.6542L14.1175 32.4703L15.8825 31.5297ZM18.283 23.7136L14.1175 31.5297L15.8825 32.4703L20.048 24.6542L18.283 23.7136Z",
    fill: "white",
    mask: "url(#path-1-inside-1_5059_6321)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5059_6321",
    x: 0,
    y: 0,
    width: 30,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5059_6321"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5059_6321",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivePin);
export default __webpack_public_path__ + "static/media/inactive-pin.8dd211711b35e4598cf08203bd627371.svg";
export { ForwardRef as ReactComponent };